module.exports = __webpack_public_path__ + "fonts/NespressoLucas-Italic.woff2?v=a5bded6fcc2d45cc0deb9cd0b1fce006";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-Italic.woff2
// module id = 652
// module chunks = 0